import { FormControlLabel, Radio } from "@mui/material"

export function ScheduleCommentaryMoveOption({ item }) {
    return (
        <FormControlLabel
            value={item.id}
            control={<Radio />}
            label={item.title}
            data-cy="schedule-commentary-move-dialog-option"
        />
    )
}
